import { cva } from "cva";
import {
  Popover as AriaPopover,
  PopoverProps as AriaPopoverProps,
  composeRenderProps,
  OverlayArrow,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";

export interface PopoverProps extends Omit<AriaPopoverProps, "children"> {
  showArrow?: boolean;
  children: React.ReactNode;
}

const styles = cva({
  base: "bg-white dark:bg-black",
  variants: {
    // isEntering: {
    //   true: "animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 ease-out duration-200",
    // },
    // isExiting: {
    //   true: "animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 ease-in duration-150",
    // },
  },
});

export function Popover({
  children,
  className,
  showArrow,
  ...props
}: PopoverProps) {
  return (
    <AriaPopover
      offset={0}
      containerPadding={55}
      {...props}
      className={(renderProps) =>
        twMerge(
          styles(renderProps),
          composeRenderProps(className, (className) => className)(renderProps),
        )
      }
    >
      {showArrow && (
        <OverlayArrow className="group">
          <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            className="group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90 block fill-white dark:fill-black"
          >
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>
      )}
      {children}
    </AriaPopover>
  );
}
